

















import Vue from 'vue';
// import brand, { BrandData, Brand } from '@/modules/exhibitor/brand';
import {
  brand,
  Brand,
  BrandData,
} from 'mostra';

interface DataType {
  loading: boolean;
  brand: BrandData | null;
  brands: Brand[] | null;
  owner: string | null
}

export default Vue.extend({
  name: 'exhibitor-brand-top',
  data(): DataType {
    return {
      loading: true,
      brand: null,
      brands: null,
      owner: null,
    };
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;
        this.$loading(true);
        this.owner = this.$auth.cid;
        if (this.brands === null) {
          this.brands = await brand.loadsByOwner(this.$auth.cid);
        }
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
        this.$loading(false);
      }
    },
    toCreatePage() {
      this.$router.push({
        name: 'exhibitor-brand-new',
        query: { page: 'settings' },
      });
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    await this.fetchData();
  },
  async mounted() {
    await this.fetchData();
  },
});
